import { CircularProgress } from "shared";
import * as React from 'react';
import styles from './loading-overlay.module.scss'

export const CustomLoadingOverlay = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.background}/>
            <CircularProgress size={50} className={styles.progress}/>
        </div>
    );
}
